import { FrameName } from "../config";
import ShallowSeaRocksLighthouseBuildingTileEntity from "./ShallowSeaRocksLighthouseBuildingTileEntity";

class LighthouseBuildingTileEntity extends ShallowSeaRocksLighthouseBuildingTileEntity {
	public static readonly frameName = FrameName.LIGHTHOUSE;
}

export default LighthouseBuildingTileEntity;
